import React, { useState, useEffect } from "react";
import "./Navbar.css";
import NavbarItem from "./NavbarItem";
import MenuCont from "../Menu/MenuCont";
import { Link } from "react-router-dom";

export default function NavbarCont({
  articles,
  coverArticles,
  historyArticles,
  textosMillonariosArticles,
  historiasMonumentalesArticles,
  home
}) {
  const [search, setSearch] = useState("");
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Función que actualiza el ancho del navegador
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    // Escucha el evento de redimensionamiento de la ventana
    window.addEventListener('resize', handleResize);

    // Limpia el evento cuando el componente se desmonta
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    let filtered = articles;

    if (search.length > 2) {
      filtered = filtered.filter(
        (article) =>
          article.title.toLowerCase().includes(search.toLowerCase()) ||
          (article.tags &&
            article.tags.some((tag) =>
              tag.toLowerCase().includes(search.toLowerCase())
            ))
      );
    }

    setFilteredArticles(filtered);
  }, [search]);
  const [openSearch, setOpenSearch] = useState(false);

  const openSearcher = () => {
    setOpenSearch(!openSearch);
  };

  // useEffect(() => {

  //     setOpenSearch(!openSearch);

  // }, [search]);
  return (
    <nav className="navbar-cont">
      <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to={`/`} className="navbar-logo-cont">
        <img
          className="navbar-sidebar-logo"
          src="https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/logo1986_square.png?alt=media&token=dde69511-bd57-4924-9174-44859fa5a516"
          alt=""
        />
      </Link>

      <div className="navbar-items-cont"></div>
      <div
        className={`navbar-searcher-cont ${
          openSearch ? "navbar-searcher-cont-open" : ""
        } `}
      >
        {home ? 
        <>
        {openSearch ? 
        

        <>
        <div className="navbar-searcher-cont-column">
          {openSearch ? <p className="title red-and-bold">BUSCADOR</p> : <></>}
          <input
            className="input"
            placeholder="Buscar artículos..."
            type="text"
            onChange={(e) => setSearch(e.target.value)}
          />
      
            <img
              className="delete-search"
              onClick={() => {
                setSearch("");
                openSearcher()
              }}
              width="15"
              height="15"
              src="https://img.icons8.com/color/48/cancel--v1.png"
              alt="cancel--v1"
            />
       
        </div>

        <div className="navbar-searcher-items-cont">
          {search.length > 2 ? (
            filteredArticles.map((article, index) => (
              <Link
                to={`/article/${article.id}`}
                key={index}
                className="navbar-searcher-item"
              >
                <img
                  className="navbar-searcher-item-cover"
                  src={article.cover}
                  alt="cover"
                />
                <div className="column50w">
                  <p className="navbar-searcher-item-title">
                    {" "}
                    {article.title}{" "}
                  </p>
                  <p className="top-item-category"> {article.category} </p>
                  <p className="top-item-author">Por {article.author}</p>
                </div>
              </Link>
            ))
          ) : (
            <></>
          )}
        </div>
        </>
: 

<img className="searcher-lupa" onClick={openSearcher} width="20" height="20" src="https://img.icons8.com/ios-filled/50/search--v1.png" alt="search--v1"/>
      }
        </> : <></>}
        
        
      </div>

      <MenuCont
        coverArticles={coverArticles}
        historyArticles={historyArticles}
        textosMillonariosArticles={textosMillonariosArticles}
        historiasMonumentalesArticles={historiasMonumentalesArticles}
      />
    </nav>
  );
}
